/**
 * @module Directives.Paywalls
 *
 */
import template from 'ngapp/templates/views/paywalls/_explicit_modal.html';
import explicit_icon_png from 'app/images/paywall-body-icon-explicit.png';

/**
 * @class ExplicitModal
 *
 */
function Controller($scope, tracking) {
  $scope.modal = $scope.$props.modal;
  $scope.onCancel = onCancel;
  $scope.feature = 'Explicit';
  $scope.explicit_icon_png = explicit_icon_png;

  tracking.paywalls.shown($scope.feature);

  function onCancel() {
    $scope.modal.dismiss();
  }
}

Controller.$inject = ['$scope', 'core.services.tracking'];

export default {
  bindings: {
    modal: '<'
  },
  template,
  controller: Controller,
  controllerAs: '$props'
};
